import countries from 'country-list'

export default function getCountryCode(country) {
  if (!country) return ''
  country = country.toLowerCase().replace(/[^a-z]/g, '')
  if (
    [
      'us',
      'usa',
      'untiedstates',
      'unitedstatest',
      'unitedstatesofamerica',
      'unitedstatesl',
      'unitedstates',
      'unitedstated',
      'unitedstate'
    ].includes(country)
  ) {
    return 'US'
  }

  if (['ca', 'can', 'canada'].includes(country)) {
    return 'CA'
  }

  return countries.getName(country.toUpperCase()) ? country.toUpperCase() : countries.getCode(country) || 'US'
}

const countryList = countries.getNames().sort()

;['Mexico', 'Canada', 'United States of America'].forEach((c) => {
  countryList.splice(countryList.indexOf(c), 1)
  countryList.unshift(c)
})

export { countryList }
